// extracted by mini-css-extract-plugin
export var margin = "separator-module--margin--c29cd";
export var separator = "separator-module--separator--2974a";